import React from 'react';
import OffersEmptyClockIcon from 'shared/assets/svg/offers-empty-clock.svg?react';
import type {OffersTab} from '../../model/offersFilters';
import styles from './OffersEmptyState.module.css';

interface OffersEmptyStateProps {
	tab: OffersTab;
	onShowAll: () => void;
}

export function OffersEmptyState({tab, onShowAll}: OffersEmptyStateProps): React.ReactElement {
	const content =
		tab === 'invited'
			? {
					title: 'Нет приглашений',
					text: 'Подождите, когда вас пригласят, или посмотрите другие предложения',
				}
			: tab === 'applied'
				? {
						title: 'Нет активных откликов',
						text: 'Вы можете посмотреть другие предложения и откликнуться на них',
					}
				: {
						title: 'Пока нет предложений',
						text: 'Когда появятся новые предложения, они отобразятся здесь',
					};

	return (
		<div className={styles.card}>
			<div className={styles.icon} aria-hidden>
				<OffersEmptyClockIcon />
			</div>
			<div className={styles.content}>
				<h2 className={styles.title}>{content.title}</h2>
				<p className={styles.text}>{content.text}</p>
				{tab !== 'all' && (
					<button type="button" className={styles.showAllButton} onClick={onShowAll}>
						Все предложения
					</button>
				)}
			</div>
		</div>
	);
}
